export default "__VITE_ASSET__BmVhPY1e__"